var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"巡逻人员","name":"emp"}},[_c('AttPatrolEmp')],1),_c('el-tab-pane',{attrs:{"label":"巡逻记录","name":"records"}},[_c('AttPatrolClock')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }